import { render, staticRenderFns } from "./cock-fight.vue?vue&type=template&id=1951f0db"
import script from "./cock-fight.vue?vue&type=script&lang=js"
export * from "./cock-fight.vue?vue&type=script&lang=js"
import style0 from "./cock-fight.vue?vue&type=style&index=0&id=1951f0db&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1951f0db')) {
      api.createRecord('1951f0db', component.options)
    } else {
      api.reload('1951f0db', component.options)
    }
    module.hot.accept("./cock-fight.vue?vue&type=template&id=1951f0db", function () {
      api.rerender('1951f0db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cock-fight.vue"
export default component.exports